import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

import { PLATFORM_PARAM } from './platform.guard';

/**
 * Never reuses a screen across platforms.
 *
 * Switching platform keeps the screen (`/p/harley/security/users` → `/p/overa/security/users`, see
 * `switchPlatformUrl`), so only the `:platform` param changes. The default strategy reuses a route whose
 * `routeConfig` is the same, so the screen stayed alive showing the previous platform's data: the screens
 * load on init. Refusing reuse on the `p/:platform` route recreates its whole subtree, which reloads the
 * list and lets the security shell restore and re-enter its tenant scope for the new platform.
 */
@Injectable()
export class PlatformRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return (
      super.shouldReuseRoute(future, curr) &&
      future.params[PLATFORM_PARAM] === curr.params[PLATFORM_PARAM]
    );
  }
}
